import {
  Form,
  Button,
  Row,
  Col,
  Checkbox
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomDropDown from "../customDropDown/customDropDown";
import {
  useForm,
} from "react-hook-form";

import './repoEntryDetails.scss'
import {
  DatePickerField,
  DropdownField,
  Field,
  FileUploadField,
  RadioField,
  TextField,
  TextAreafield,
  CascadeDropdownField,
  ApiValues,
  SearchableField,
} from "../../types/field";
import CustomDatePicker from "../datePicker/datepicker";
import moment from "moment";
import { InputComponent } from "../input/inputuncontrolled"
import {
  filterNullValues,
  getIndexOfAccessLevel,
  getIndexOfAccessLevelFromVal,
  getIndexOfPlatformAction,
  getIndexOfPlatformActionFromVal,
} from "../../utils/utils";
import { AccessLevel, ExtraRecordLevelActions, ReportingToUser, RowLevelAction, StepAction, platformActionLabelsType } from "../../types/types";
import CustomFileUpload from "../fileupload/fileupload";
import { Notification } from "../notification/notification";
import TextAreaInput from "../textArea/textArea";
import CascadeDropDown from "../customDropDown/cascadeDropDown";
import CustomRecordDetailModal from "../modal/customRecordDetailModal";
import { apiAliasMapper, convertToDouble, dataApiType, dataTypeHandling, evaluateVisibilityOfAction, executeExtraAction, filterNonCreatableFields, filterNonUpdatableFields, getApiForField, getViewApi, handleLoanNumberLookUp, handleOnBlurOnField, isFieldEditable, isMandatoryField, mapCreateApiToAliasNames, mapViewApiToAliasNames, refreshFieldsBasedOnVisibility, refreshFormulaFields } from "./recordDetailUtils";
import CommonRadioGroup from "../CommonRadioGroup/CommonRadioGroup";
import CustomDateTimePicker from "../dataAndTimePicker/datetimepicker";
import { AdressInputComponent } from "../addressInputComponent/addressInputComponent";
import { SearchableInputComponent } from "../searchableInputComponent/searchableInputComponent";
import { GetRequest, PostRequest, PutRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";
import { refineApiWithUrlParams } from "./detailsPageCommonsUtils";
import CustomLoader from "../loader";
import { isMobile } from "react-device-detect";
import { getRegexForValidation } from "../../utils/getRegexForValidation";
import { renderSubHeading, splitArray } from "./detailsPagesUtils";

interface Props {
  urlparams: Map<string, string>;
  recordId: string;
  platformAction: RowLevelAction;
  createApi: string;
  dataApi: string;
  dataApis?: dataApiType[];
  dataApiMapper?: apiAliasMapper[];
  createApiMapper?: apiAliasMapper[];
  viewApi?: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  editForm: Field[];
  setOpen: Function;
  dependantFields?: any;
  userAccessLevel: AccessLevel;
  parentEntity?: string;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable?: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  moduleCode: string;
  mulitiDependency?: boolean,
  title?: string
  paymentModeList?: any[];
  viewPageBluPrint: any;
  extraActionsOnRecord?: ExtraRecordLevelActions[];
  platformActionLabels?: platformActionLabelsType[];
  hideActions?: Array<string>;
  enableStepNext?: boolean;
  enableStepSubmit?: boolean;
  enableStepBack?: boolean;
  onStepAction?: Function;
}

interface RepoChargesApprovalInfo {
  componentCode: number,
  maxRepoChargesAmount: number,
  platformPojoName: string,
  authorityRole: string,
  minRepoChargesAmount: number,
}

interface RepoChargesFieldApprover {
  approverEcode?: string,
  approverName?: string,
  approverRoleCode?: string,
  approverRoleName?: string,
  field: string,
}

const RepoEntryDetails: React.FC<Props> = ({
  recordId,
  editForm,
  dataApi,
  urlparams,
  dataApis,
  viewPageBluPrint,
  viewApi = getViewApi(dataApis, dataApi, urlparams),
  createApi,
  isCreateFlow,
  isRelatedInfo,
  setOpen,
  dependantFields,
  userAccessLevel,
  platformAction,
  parentEntity = undefined,
  recordIds,
  loanNos,
  customerNames,
  refreshTable = () => { },
  allowEdits,
  selectedRows,
  moduleCode,
  dataApiMapper,
  createApiMapper,
  extraActionsOnRecord,
  platformActionLabels,
  hideActions,
  enableStepNext,
  enableStepSubmit,
  enableStepBack,
  onStepAction
}) => {
  const [formSchema, setFormSchema] = useState<Field[]>([]);
  const [loading, setLoading] = useState<Boolean>(true);
  const [dynamicFieldCounter, setDynamicFieldCounter] = useState<number>(1);
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [viewData, setViewData] = useState<any>();

  const [hideEdit, setHideEdit] = useState(false)
  const [selectCheckBox, setSelectCheckBox] = useState(false);

  const [repoChargesApprovalMatrixData, setRepoChargesApprovalMatrixData] = useState<RepoChargesApprovalInfo[]>([]);
  const [upwardReportingUserData, setUpwardReportingUserData] = useState<ReportingToUser[]>([]);
  const [repoChargeFieldApprovers, setRepoChargeFieldApprovers] = useState<RepoChargesFieldApprover[]>([]);
  const [finalApprovingAuthorityUser, setFinalApprovingAuthorityUser] = useState<ReportingToUser>();
  const [isRecordAlreadyExists, setIsRecordAlreadyExists] = useState<boolean>(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const { t } = useTranslation();
  const {
    control,
  } = useForm<any>({});

  const [form] = Form.useForm();

  const resetField = (field: string) => {

    const temp = {
      [field]: undefined
    }
    form.setFieldsValue(temp);
  }


  const submitBtn = useRef<any>();

  const setError = (field: string, error: any) => {

    form.setFields([
      {
        name: field, // Field name
        errors: [error.message], // Array of error messages
      }
    ]);
  }


  useEffect(() => {

    if (isMobile) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log("Latitude: ", position.coords.latitude);
            console.log("Longitude: ", position.coords.longitude);
          },
          (error) => {
            console.error("Error getting geolocation: ", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    }



  }, []);

  useEffect(() => {
    getViewData("user-hierarchy/report-to-manager/all")
      .then((data: any) => {
        let reportToManagers: ReportingToUser[] = data?.records ?? [];
        if (reportToManagers.length > 0) {
          setUpwardReportingUserData(reportToManagers);
        }
      });

    getViewData("reposession-waiver/platform/api/repocharges-approval-matrix?size=100&page=0")
      .then((data: any) => {
        let repoApprovalInfos: RepoChargesApprovalInfo[] = data.records;
        if (repoApprovalInfos.length > 0) {
          setRepoChargesApprovalMatrixData(repoApprovalInfos);
        }
      });

  }, []);

  const renderApprovingAuthorityInfo = (field: Field) => {
    const approvalReqInfo = repoChargeFieldApprovers.find(approver => approver.field === field.field);
    if (approvalReqInfo?.approverEcode === undefined || approvalReqInfo.approverEcode === null) {
      return <></>;
    }
    return (<div className={"repo-approver-div"}>
      <div className="waiver-head-note mx-3 px-2 rounded">
        <span className="font-medium">Approving Authority : </span>
        <span className="font-semibold">
          {approvalReqInfo.approverEcode} - {approvalReqInfo.approverName} ({approvalReqInfo.approverRoleName})
        </span>
      </div>

    </div>);
  }

  useEffect(() => {
    if (formSchema && upwardReportingUserData && upwardReportingUserData.length > 0 && repoChargesApprovalMatrixData && repoChargesApprovalMatrixData.length > 0) {
      
      setInputFieldsValuesObj();
      
      if (repoChargeFieldApprovers.length === 0) {

        const vals = form.getFieldsValue();

        setRepoChargeFieldApprovers(repoChargesApprovalMatrixData?.map((field: RepoChargesApprovalInfo) => { return { field: field.platformPojoName } }));
        
        formSchema.forEach(field => {
          let val = vals[field.field];
          if (val) {
            computeApprovingAuthority(field.field, val);
          }
        });
      }
    }

  }, [upwardReportingUserData, repoChargesApprovalMatrixData, formSchema]);

  const computeApprovingAuthority = (field: string, value: string) => {
    const approvalAmountField: RepoChargesApprovalInfo | undefined = repoChargesApprovalMatrixData.find(matrix => matrix.platformPojoName === field);
    if (approvalAmountField === undefined || value === undefined) {
      return;
    }
    const chargeAmount: number | null = convertToDouble(value);
    setRepoChargeFieldApprovers(repoChargeFieldApprovers => {
      const updatedData = repoChargeFieldApprovers.map(obj => {
        if (obj.field === field) {
          if (chargeAmount == null) {
            return { field };
          }
          const repoApprovalsAmountInfo: RepoChargesApprovalInfo | undefined = repoChargesApprovalMatrixData.filter(matrix => matrix.platformPojoName === field)
            .find(matrix => (chargeAmount >= (matrix.minRepoChargesAmount ?? 0) && chargeAmount <= (matrix.maxRepoChargesAmount ?? 0)));

          if (repoApprovalsAmountInfo && repoApprovalsAmountInfo.hasOwnProperty("authorityRole")) {
            const reportingToUser: ReportingToUser | undefined = upwardReportingUserData.find(user => user.roleCode === repoApprovalsAmountInfo.authorityRole!);
            return { ...obj, approverEcode: reportingToUser?.ecode, approverName: reportingToUser?.name, approverRoleName: reportingToUser?.roleName };
          } else {
            return { field }
          }
        }
        return obj;
      });
      return updatedData;
    });
  };

  useEffect(() => {
    computeFinalApprovingAuthority();
  }, [repoChargeFieldApprovers])

  const computeFinalApprovingAuthority = () => {
    let finalApprovingAuth: ReportingToUser | undefined;
    const approvingAuthorities = new Set(repoChargeFieldApprovers
      .filter(approver => approver.approverEcode !== undefined && approver.approverEcode !== null)
      .map(approver => approver.approverEcode));

    for (const reportingUser of upwardReportingUserData) {
      if (approvingAuthorities.has(reportingUser.ecode)) {
        finalApprovingAuth = reportingUser;
        break;
      }
    }
    setFinalApprovingAuthorityUser(finalApprovingAuth);
  }

  const renderFinalApprovingAuthority = () => {
    return finalApprovingAuthorityUser ? (

      <div className="waiver-head-note mx-3 px-2 rounded">
        <span className="font-medium">Final Approving Authority : </span>
        <span className="font-semibold">
          {finalApprovingAuthorityUser.ecode} - {finalApprovingAuthorityUser.name} ({finalApprovingAuthorityUser.roleName})
        </span>
      </div>
    ) : <></>;
  }

  const getViewData = (endpoint: string): Promise<Response> => {


    endpoint = refineApiWithUrlParams(endpoint, urlparams);
    return GetRequest(endpoint);
  };

  // reconverted to redux as this is dependant on table
  const CreateNewRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ) => {

    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {

        await PostRequest(endpoint, data, moduleCode);

        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);
        setOpen(false);
        return true;
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }

    return false;
  };
  // reconverted to redux as this is dependant on table
  const UpdateRecord = async (
    endpoint: string,
    recordId: string,
    data: any
  ): Promise<boolean> => {
    if (endpoint?.length > 0) {
      setSaveLoading(true);
      endpoint = endpoint?.replace("{recordId}", recordId);
      try {


        await PutRequest(endpoint, filterNonUpdatableFields(data, formSchema), moduleCode);

        Notification("success", "Saved Successfully");
        refreshTable();
        setSaveLoading(false);
        setOpen(false);
        setIsEditClicked(false);
        return true;
      } catch (err: any) {
        setSaveLoading(false);
        if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
          let unknownFieldErrors: string[] = [];
          err?.response?.data.errorMessages.forEach((errorMessage: any) => {
            let errField = errorMessage.field;
            const fieldExists = formSchema.some((x) => x.field === errField && x.display !== false);
            if (fieldExists) {
              setError(errField, {
                type: "focus",
                message: errorMessage.message,
              });
            } else {
              unknownFieldErrors.push(errorMessage.message);
            }
          });
          if (unknownFieldErrors.length > 0) {
            Notification("error", unknownFieldErrors.join('\n'));
          }
        } else {
          Notification("error", err?.response?.data?.message ?? "Transaction Failed");
        }
      }
    }

    return false;
  };

  const filterReadOnlyFields: any = (data: any) => {
    let editPayload: any = { ...data };
    let readOnlyFields = formSchema
      .filter((x) => !x.editable && x.fieldType !== 'formula')
      .map(({ field }) => field);
    Object.keys(data).forEach((key, index) => {
      if (readOnlyFields.includes(key)) {
        delete editPayload[key];
      }
    });
    return editPayload;
  };



  const onSubmit = (data: any, event?: any) => {

    data = filterNullValues(data);
    
    // remove readonly fields in case of edit form
    if (!isCreateFlowRequired() || isRecordAlreadyExists) {
      data = filterReadOnlyFields(data);
    } else {
      data = filterNonCreatableFields(data, formSchema);
    }

    data = mapCreateApiToAliasNames(data, viewData, urlparams, createApiMapper);

    if (data.toBeDepositedAmount) {
      if ((data.depositedAmount > data.toBeDepositedAmount) && Number(data.excessAmount) != (Number(data.depositedAmount) - Number(data.toBeDepositedAmount))) {
        Notification("error", "Invalid Excess Amount");
        return true;
      }
      if ((data.depositedAmount < data.toBeDepositedAmount) && Number(data.shortAmount) != (Number(data.toBeDepositedAmount) - Number(data.depositedAmount))) {
        Notification("error", "Invalid Short Amount");
        return true;
      }
      if (Number(data.toBeDepositedAmount) != Number(data.depositedAmount) + Number(data.shortAmount) - Number(data.excessAmount)) {
        Notification("error", "Invalid Short or Excess Amount");
        return true;
      }
    }

    let fileChildEntities = formSchema
      .filter(
        (field) => field.childEntity && field.fieldType === "fileUpload"
      )
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field };
      });

    fileChildEntities.forEach(({ chilldEntity, field }) => {
      if (!data[chilldEntity!]) {
        data[chilldEntity!] = data[field];
        delete data[field];
      }
    });


    let childEntities = [...formSchema]
      .filter((field) => field.childEntity && field.fieldType !== "fileUpload")
      .map((f) => {
        return { chilldEntity: f.childEntity, field: f.field, iterate: f.iterate ?? false };
      });
    childEntities.forEach(({ chilldEntity, field, iterate }) => {
      let childItems: any = [];
      if (iterate) {
        let multiValuesData: [] = Array.isArray(data[field]) ? data[field] : data[field]?.split(',');
        multiValuesData?.forEach((value) => {
          let item: any = {};
          item[field] = value;
          childItems.push(item);
        });
      } else {
        let childFormData = data[chilldEntity!]?.[0] ?? {};
        childFormData[field] = data[field];
        childItems.push(childFormData);
      }
      data[chilldEntity!] = [...childItems];
    });

    childEntities.forEach(({ chilldEntity, field }) => {
      delete data[field];
    });

    //this is to pass unique ids as a part of payload
    if (recordIds && recordIds.length > 0) {
      if (moduleCode === "systemPis") {
        let paymentMode = ["Q", "P", "D"].includes(selectedRows?.[0]?.paymentMode) ? 'B' : 'C';
        data["paymentMode"] = paymentMode
      }
      else if (moduleCode === "kPis") {
        data["paymentMode"] = selectedRows?.[0]?.paymentMode;
      } else if (moduleCode === "callsReview" || moduleCode === "visitsReview") {
        data["loanNos"] = loanNos;
        data["customerNames"] = customerNames;
      }
      data["recordIds"] = recordIds;
    } else if (moduleCode === "todo") {
      data["tcCallsId"] = recordId;
    } else if (moduleCode === "fIAllocation") {
      data["leadMstId"] = recordId;
    }

    if (parentEntity) {
      // let dat = [{ ...data }];
      let f: any = {};
      f[parentEntity] = [{ ...data }];
      data = f;
    }

    let extraActionButton: ExtraRecordLevelActions | undefined = undefined;
    let buttonActionType: string | undefined = undefined;

    if (submitBtn && submitBtn.current) {

      const clickedButton = submitBtn.current;
      const buttonValue = clickedButton.value ? JSON.parse(clickedButton.value) : undefined;

      if (buttonValue && buttonValue.actionType === 'javascript') {
        extraActionButton = buttonValue;
      }

      if (buttonValue) {
        buttonActionType = buttonValue.actionType;
      }

    }

    let apiResponse: Promise<boolean> | undefined = undefined;
    if (extraActionButton) {
      executeExtraAction(recordId, form.getFieldsValue(), urlparams, extraActionButton, refreshTable, setOpen, setError);
    }
    else if (isRecordAlreadyExists) {
      if (createApi.includes("/composite/")) {
        apiResponse = UpdateRecord(refineApiWithUrlParams(createApi, urlparams), recordId, data);
      } else {
        apiResponse = UpdateRecord(refineApiWithUrlParams(createApi + "/{repoKitNo}", urlparams), recordId, data);
      }
    }
    else if (isCreateFlowRequired()) {
      apiResponse = CreateNewRecord(createApi, recordId, data);
      // setIsEditClicked(false);
    } else {
      apiResponse = UpdateRecord(dataApi, recordId, data);
    }

    if (buttonActionType) {
      apiResponse?.then(res => {
        if (res && buttonActionType === "stepActionNext") {
          onStepAction && onStepAction(StepAction.NEXT);
        } else if (res && buttonActionType === "stepActionSubmit") {
          onStepAction && onStepAction(StepAction.SUBMIT);
        }
      }).catch(error => {
        console.log("saving data failed.");
      })
    }
  };

  const isCreateFlowRequired = (): boolean => {
    return (
      isCreateFlow ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.TRANSFER) ||
      getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)
    );
  };

  useEffect(() => {
    if ((getIndexOfPlatformAction(platformAction) ===
      getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)) ||
      (getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.EDIT))) {
      setIsEditClicked(true);
    }
  }, [platformAction]);

  useEffect(() => {
    if (
      viewApi?.length > 0 &&
      (!isCreateFlow ||
        getIndexOfPlatformAction(platformAction) ===
        getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT) ||
        isRelatedInfo)
    ) {

      getViewData(createApi + "/{repoKitNo}")
        .then((data: any) => {

          if (data === null || data === undefined || Object.keys(data).length === 0) {

            setIsRecordAlreadyExists(false);

            getViewData(viewApi)
              .then((data: any) => {
                setViewData(mapViewApiToAliasNames(data, dataApiMapper));
                form.setFieldsValue(dataTypeHandling(mapViewApiToAliasNames(data, dataApiMapper), editForm));
              });

          } else {
            setIsRecordAlreadyExists(true);
            setViewData(mapViewApiToAliasNames(data, dataApiMapper));
            form.setFieldsValue(dataTypeHandling(mapViewApiToAliasNames(data, dataApiMapper), editForm));
          }
        })
        .catch(error => {
          setIsRecordAlreadyExists(false);
          getViewData(viewApi)
            .then((data: any) => {
              setViewData(mapViewApiToAliasNames(data, dataApiMapper));
              form.setFieldsValue(dataTypeHandling(mapViewApiToAliasNames(data, dataApiMapper), editForm));
            })
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (viewApi === undefined || viewApi?.length === 0) {
      setLoading(false);
    }
  }, [viewApi, recordId]);

  const filterFormFields = () => {
    return refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, form.getFieldsValue, form.setFieldValue, resetField, formSchema);
  };

  const getFormSchema = useCallback(() => {
    let formFields = filterFormFields();
    setFormSchema(formFields);
    formFields?.map((field: any) => {
      if (field.fieldType !== "actionButton") {
        setHideEdit(field?.editable)
      }
    });

  }, [editForm]);

  useEffect(() => {
    getFormSchema();
  }, [editForm]);

  const setInputFieldsValuesObj = () => {

    let tempInputFields: any = {};

    if (formSchema) {
      formSchema?.forEach((item: any) => {
        if (item?.field) {
          tempInputFields[item?.field] = null;
        }
      });
    }

    //set default value for checkbox
    formSchema?.forEach((item: any) => {
      if (item && item.fieldType === 'checkBox') {
        form.setFieldValue(item.field, form.getFieldsValue()[item.field] || false)
      }
    });

  };

  const valueStore = useRef<any>();

  useEffect(() => {
    form.setFieldsValue(valueStore.current);
  }, [formSchema]);

  const handleOnChange = (value: string, field: string, isCheckBox: boolean = false) => {

    // if (!isCheckBox) {
    //   if (!value || (Array.isArray(value) && value.length === 0)) {
    //     return;
    //   }
    // }

    // if (!value || (Array.isArray(value) && value.length === 0)) {
    //   return;
    // }

    //Need to store this in ref variable to rerender after formSchema is updated
    const temp = form.getFieldsValue(true)
    temp[field] = value;

    form.setFieldsValue(temp);

    valueStore.current = temp;

    computeApprovingAuthority(field, value);

    const currentForm = refreshFieldsBasedOnVisibility(editForm, isCreateFlow ?? false, form.getFieldsValue, form.setFieldValue, resetField, formSchema);

    const setValue = (field: string, val: any) => {
      form.setFieldValue(field, val);
      const temp = valueStore.current;
      temp[field] = val;
      valueStore.current = temp;
    }

    refreshFormulaFields(editForm, form.getFieldsValue, setValue, editForm);

    setFormSchema([...currentForm]);
    // form.validateFields([field]);

  };

  const handleCascadeOnChange = (value: string, field: string) => {

    // TODO: doesnt work in internet explorer need polyfill
    // api url for cascade fields will be empty handled at client side.
    let indexOfFieldToRefresh = formSchema.findIndex(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField === field
    );

    // fetch field from editform as this has the api urls for the cascade fields
    let fieldData = editForm.find(
      (f: any) => f.valuesDependOnField && f.valuesDependOnField == field
    );

    if (
      indexOfFieldToRefresh === -1 ||
      fieldData === null ||
      fieldData === undefined
    ) {
      return;
    }

    let fieldToRefresh = { ...formSchema[indexOfFieldToRefresh] };

    if (viewData[fieldToRefresh.field]) {
      delete viewData[fieldToRefresh.field];
    }

    if (urlparams.has(fieldToRefresh.field)) {
      urlparams.set(fieldToRefresh.field, "");
    }

    // modify api query params based on selection
    let api = fieldData.api;
    let apiWithQueryParams = `${api}&search=${field}:in${value}`;
    fieldToRefresh.api = apiWithQueryParams;

    // update field at certain index
    const newFormSchema = [...formSchema];
    newFormSchema[indexOfFieldToRefresh] = fieldToRefresh;

    // update state with new formfields
    setFormSchema(newFormSchema);
    resetField(fieldToRefresh.field);
  };

  const handleOnBlur = async (
    value: any,
    field: string,
    lookupField?: string,
    lookupFieldUrl?: string
  ) => {
    if (!lookupField || !lookupFieldUrl || value === "") {
      return;
    }
    handleLoanNumberLookUp(value, lookupField, lookupFieldUrl)
      .then((customerName) => {
        form.setFieldValue(lookupField, customerName);
        // clearErrors(field);
      })
      .catch((error) => {
        setError(field, error);
      });
  };



  //TODO: this is a temporary fix need to find a proper way to add grouped fields
  const addGroupFieldBehaviour = () => {

    let editFields = [...formSchema];

    if (
      createApi !==
      "payments/composite/platform/{version}/api/payment-collection-composition"
    ) {
      return;
    }

    let receiptNatureCode = editFields.find(
      (field) => field.field === "receiptNatureCode"
    );

    let receiptNatureAmount = editFields.find(
      (field) => field.field === "receiptNatureAmount"
    );

    let receiptNatureCodeClone = { ...receiptNatureCode } as Field;
    receiptNatureCodeClone.isGroupedField = true;

    let receiptNatureCodeClone1 = { ...receiptNatureCode } as Field;
    receiptNatureCodeClone1.isGroupedField = true;
    receiptNatureCodeClone1!.field = `${receiptNatureCodeClone1?.field}${dynamicFieldCounter}`;

    let receiptNatureAmountClone = { ...receiptNatureAmount } as Field;
    receiptNatureAmountClone.isGroupedField = true;

    let receiptNatureAmountClone1 = { ...receiptNatureAmount } as Field;
    receiptNatureAmountClone1.isGroupedField = true;
    receiptNatureAmountClone1!.field = `${receiptNatureAmountClone1?.field}${dynamicFieldCounter}`;

    let tempForm: Array<Field> = [];

    tempForm = tempForm.concat();
    tempForm = [
      ...editFields
        .filter((field) => field.field !== "receiptNatureAmount")
        .filter((field) => field.field !== "receiptNatureCode"),
    ];
    tempForm.splice(2, 0, receiptNatureCodeClone);
    tempForm.splice(3, 0, receiptNatureAmountClone);
    tempForm.splice(2 + 2 * dynamicFieldCounter, 0, receiptNatureCodeClone1);
    tempForm.splice(3 + 2 * dynamicFieldCounter, 0, receiptNatureAmountClone1);

    setFormSchema(tempForm);
    setDynamicFieldCounter(dynamicFieldCounter + 1);
    //return tempForm;
  };


  // Start of Form Fields render methods
  // Below methods should be same in all record details pages - If any change is made - copy the whole to other record details page
  const renderTextBox = (field: TextField) => {
    return field.field === "receiptNatureAmount"
      ? renderTextBoxWithButton(field)
      : renderPlainTextBox(field);
  };

  const renderTextAreainput = (field: TextField) => {

    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
              message: "Please enter the value.",
            },
          ]}
        >
          <TextAreaInput
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={form.setFieldValue}
            placeholder={field?.placeholder}
            // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            rules={field?.rules && field?.rules[0]}
            maxLength={field?.rules[0].maxSize}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderPlainTextBox = (field: TextField) => {

    //DND - Needed for expressions in blueprint
    const currentDate = moment();

    return (
      <Col span={24} lg={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}
            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? getRegexForValidation(field?.rules[0]?.allowValues).value : undefined,
                message: "Please enter valid value.",
              }
            ]}
          >

            <InputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={form.setFieldValue}
              placeholder={field?.placeholder}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onBlur={(e: any) => {

                handleOnChange(e, field.field);

                const setValue = (newVal: any) => {
                  form.setFieldValue(field.field, newVal);
                }

                handleOnBlurOnField(field, setError, setValue, editForm, form.getFieldsValue, urlparams, {});

                return field.lookupField && field.lookupFieldEndpoint
                  ? handleOnBlur(e, field.field, field.lookupField, field.lookupFieldEndpoint) : undefined

              }
              }
              onChange={(val: any) => { }}
              rules={field?.rules && field?.rules[0]}
              icon={field.icon}
            />
            {renderApprovingAuthorityInfo(field)}
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderAddressField = (field: TextField) => {
    return (
      <Col span={24} lg={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}

            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                message: "Please enter valid value.",
              },
            ]}
          >
            <AdressInputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={form.setFieldValue}
              placeholder={field?.placeholder}
              recordId={refineApiWithUrlParams("{loanNo}", urlparams)}
              // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field] || form.getFieldsValue()[field.field] || field?.rules[0].default}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(val: any) => handleOnChange(val, field?.field)}
              rules={field?.rules && field?.rules[0]}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderSearchableInputField = (field: SearchableField) => {

    return (
      <Col span={24} lg={12}>
        <>
          <Form.Item
            hidden={field?.hidden}
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}

            rules={[
              {
                required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
                message: "Please enter the value.",
              },
              {
                pattern: field?.rules?.length > 0 ? field?.rules[0]?.pattern : undefined,
                message: "Please enter valid value.",
              },
            ]}
          >
            <SearchableInputComponent
              control={control}
              name={field.field}
              title={field?.displayName}
              setValue={form.setFieldValue}
              placeholder={field?.placeholder}
              // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field] || form.getFieldsValue()[field.field] || field?.rules[0].default}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(val: any) => handleOnChange(val, field?.field)}
              rules={field?.rules && field?.rules[0]}
              searchModalProps={field.searchModalProps}
            />
          </Form.Item>
        </>
      </Col>
    );
  };

  const renderTextBoxWithButton = (field: TextField) => {

    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field?.rules?.length > 0 ? field?.rules[0]?.mandatory : false,
              message: "Please enter the value.",
            },
          ]}
        >
          <InputComponent
            control={control}
            name={field.field}
            title={field?.displayName}
            setValue={form.setFieldValue}
            placeholder={field?.placeholder}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            onChange={(val: any) => handleOnChange(val, field?.field)}
            rules={field?.rules && field?.rules[0]}
          />
          <Button type="text" danger onClick={() => addGroupFieldBehaviour()}>
            Add
          </Button>
        </Form.Item>
      </Col>
    );
  };

  const renderDropDown = (field: DropdownField) => {

    const apiValue: ApiValues = getApiForField(editForm, form.getFieldsValue, field);
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory ? true : false,
              message: "Please select the value.",
            },
          ]}
        >
          <div className="dropdown-custom">
            <CustomDropDown
              name={field?.field}
              title={field?.displayName}
              control={control}
              setValue={form.setFieldValue}
              // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : (viewData[field?.field] ?? (refineValuesWithPrefix(field.defaultValue, urlparams, "urlparam.") || field?.rules[0].default))}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(e: any) => {

                handleOnChange(e, field?.field);


                if (field.actions && field.actions.length > 0) {
                  handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
                }

              }}
              api={refineApiWithUrlParams(apiValue.api, urlparams)}
              rules={field?.rules[0]}
              dropdownCode={apiValue.dropdownCode}
              dropdownValue={apiValue.dropdownValue}
              placeholder={field?.placeholder}
              showOnlyValue={field?.rules[0].showOnlyValue}
              // value={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : (form.getFieldsValue()[field.field] || field?.rules[0].default)}
              // value={field?.field.includes(".") ? getViewDataForChildField(form.getFieldsValue(), field?.field) : form.getFieldsValue()[field?.field]}
              // value={field.rules[0].default}
              value={form.getFieldValue(field.field)}
              data={form.getFieldValue(field.field)}
              staticDropDownValues={field.staticDropDownValues ?? []}
            />
          </div>
        </Form.Item>
      </Col>
    );
  };

  const renderCascadeDropDown = (field: CascadeDropdownField) => {
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}
          rules={[
            {
              required: field.rules[0].mandatory ? true : false,
              message: "Please select the value.",
            }
          ]}
        >
          <div className="dropdown">
            <CascadeDropDown
              name={field?.field}
              title={field?.displayName}
              control={control}
              setValue={form.setFieldValue}
              data={form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(e: any) => {
                handleCascadeOnChange(e, field?.field);
                if (field.actions && field.actions.length > 0) {
                  handleOnBlurOnField(field, setError, form.setFieldValue, editForm, form.getFieldsValue, urlparams, {});
                }
              }}
              api={refineApiWithUrlParams(field.api ?? "", urlparams)}
              rules={field?.rules[0]}
              dropdownCode={field?.dropdownCode}
              dropdownValue={field?.dropdownValue}
              placeholder={field?.placeholder}
              isCascade={
                field.valuesDependOnField !== undefined &&
                field.valuesDependOnField !== null &&
                field.valuesDependOnField !== ""
              }
              showOnlyValue={field?.rules[0]?.showOnlyValue}
              parentFieldValues={viewData}
              parentFieldName={field?.valuesDependOnField}
            />
          </div>

        </Form.Item>
      </Col>
    );
  };

  const renderCalender = (field: DatePickerField) => {
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomDatePicker
            title={field?.displayName}
            data={form.getFieldValue(field.field)}
            // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : form.getFieldsValue()[field?.field] || viewData[field?.field]}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}
            onChange={(e: any) => handleOnChange(e, field.field)}
            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={form.setFieldValue}
            name={field.field}
            id={field.field}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderCalenderWithTime = (field: any) => {
    return (
      <Col span={24} lg={12}>
        <Form.Item
          label={t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CustomDateTimePicker
            title={field?.displayName}
            data={form.getFieldValue(field.field)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            showTime={field?.rules[0].showTime}
            onChange={(e: any) => handleOnChange(e, field.field)}

            rules={field?.rules[0]}
            placeholder={field?.placeholder}
            control={control}
            setValue={form.setFieldValue}
            name={field.field}
            id={field.field}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderFileUpload = (field: any) => {

    var rules = { ...field.rules[0] };
    rules.fileContext = dependantFields[0]?.field as string;

    return (
      <>
        <Col span={24} lg={12} style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Item
            label={t(field?.displayName)}
            name={field?.field}
            key={field?.displayName}

            rules={[
              {
                required: rules.mandatory,
                message: "Please select the value.",
              },
            ]}
          >
            <CustomFileUpload
              width={200}
              title={field?.displayName}
              data={field.childEntity ? form.getFieldValue(field.childEntity) : form.getFieldValue(field.field)}
              disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
              onChange={(files: any) => {
                if (field.childEntity) {
                  form.setFieldValue(field.childEntity, files);
                } else {
                  form.setFieldValue(field.field, files[0].fileName);
                }
              }
              }
              rules={rules}
              placeholder={field?.placeholder}
              control={control}
              setValue={form.setFieldValue}
              uploadApi={field.api}
              maxFilesAllowed={field.rules[0].maxFilesAllowed}
              // uploadedFileList={viewData[field?.childEntity ?? ""]}
              downloadApi={field.downloadApi}
              name={field.field}
              id={field.field}
              childEntity={field.childEntity}
              getValue={form.getFieldsValue}
            // handleAutoCompleteAction={handleAutoComplete}
            />
          </Form.Item>
        </Col>
      </>
    );
  };

  const renderRadio = (field: RadioField) => {

    return (
      <Col span={12} className="mb-2">
        <Form.Item
          label={ t(field?.displayName)}
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <CommonRadioGroup
            title={t(field?.displayName)}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
            rules={field?.rules[0]}
            api={field.api ?? ""}
            placeholder={field?.placeholder}
            onChange={(e: any) => {
              handleOnChange(e, field?.field)
            }
            }
            control={control}
            setValue={form.setFieldValue}
            name={field.field}
            options={field.values}
            // data={field?.field.includes(".") ? getViewDataForChildField(viewData, field?.field) : viewData[field?.field]}
            data={form.getFieldValue(field.field)}
            value={form.getFieldValue(field.field)}
            uiType={field.uiType}
          />
        </Form.Item>
      </Col>
    );
  };

  const renderCheckBox = (field: any) => {

    return (
      <Col span={12} >
        <Form.Item
          className="mx-1"
          name={field?.field}
          key={field?.displayName}

          rules={[
            {
              required: field.rules[0].mandatory,
              message: "Please select the value.",
            },
          ]}
        >
          <Checkbox
            type={"checkbox"}
            checked={form.getFieldValue(field.field)}
            defaultChecked={form.getFieldValue(field.field)}
            onChange={(e: any) => {

              handleOnChange(e.target?.checked, field?.field, true);

            }}
            name={field.field}
            disabled={!isFieldEditable(field, platformAction, isEditClicked, isCreateFlow ?? false)}
          >
            <label className="font-medium"> {t(field?.displayName)} </label>
          </Checkbox>
        </Form.Item>
      </Col>
    );
  };

  // End of form fields render methods

  // TODO: use enum instead of strings
  const renderField = (field: Field) => {
    if (field.display === false) {
      return;
    }
    if (selectCheckBox && (form.getFieldsValue()?.[field?.field] == '' || form.getFieldsValue()?.[field?.field] == undefined))
      return

    if (field?.rules && field?.rules[0]) {
      field.rules[0].mandatory = isMandatoryField(field, form.getFieldsValue, editForm);
    }
    if (field.fieldType === 'subHeading')
      return renderSubHeading(field as any)
    switch (field.fieldType) {
      case "textBox":
        return renderTextBox(field as TextField);
      case "formula":
        return renderTextBox(field as TextField);
      case "textArea":
        return renderTextAreainput(field as TextAreafield);
      case "address":
        return renderAddressField(field as TextField);
      case "searchableField":
        return renderSearchableInputField(field as SearchableField);
      case "dropDown":
        return renderDropDown(field as DropdownField);
      case "cascadeDropDown":
        return renderCascadeDropDown(field as CascadeDropdownField);
      case "calendar":
        return renderCalender(field as DatePickerField);
      case "radioButton":
        return renderRadio(field as RadioField);
      case "checkBox":
        return renderCheckBox(field as any);
      case "fileUpload":
        return renderFileUpload(field as FileUploadField);
      case "calendarWithTime":
        return renderCalenderWithTime(field as any)


    }
  };

  const renderActions = () =>
    formSchema?.map((field: Field) => {

      switch (field.fieldType) {
        case "actionButton":
          return field.actionInfo?.type === "modal" ? (
            <CustomRecordDetailModal
              viewPageBluPrint={viewPageBluPrint}
              title={field
                .actionInfo?.title ?? ""}
              platformAction={field.actionInfo?.launchMode}
              blueprintApi={field.actionInfo?.blueprintApi ?? ""}
              actionName={field.displayName}
              isCreateFlow={field.actionInfo?.launchMode === "Create" || field.actionInfo?.launchMode === "CreateWithContext"}
              userAccessLevel={userAccessLevel}
              moduleCode={moduleCode}
              allowEdits={
                field.actionInfo?.launchMode === "Create" ||
                field.actionInfo?.launchMode === "CreateWithContext" ||
                field.actionInfo?.launchMode === "Edit"
              }
              urlparams={urlparams}
            />
          ) : (
            <></>
          );
      }
    });

  const resetFields = () => {

    if (!isCreateFlow) {
      for (const key in form.getFieldsValue()) {
        if (viewData.hasOwnProperty(key)) {
          const value = viewData[key];
          form.setFieldValue(key, value);
          form.setFieldsValue((preVal: any) => ({
            ...preVal,
            [key]: viewData[key] || ""
          }))
        }
        else {
          form.setFieldsValue({
            [key]: ''
          })
          form.setFieldValue(key, "");
        }
      }
    }
    else {

      for (const key in form.getFieldsValue()) {
        if (form.getFieldsValue().hasOwnProperty(key)) {
          form.setFieldValue(key, "");
          // form.setFieldsValue({})
        }
      }
      if (recordId === '' && moduleCode == '') {
        const currentDate = moment();
        const formattedDate = currentDate.format('MMM-YY').toLowerCase();
        form.setFieldValue('allocationMthYr', formattedDate);
      }
    }
    getFormSchema();
  }

  const renderFields = () => {

    return splitArray(formSchema, "subHeading")?.map((field: any) => (
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24, xl: 36 }} className="w-100">

        {field.map((subField: Field) =>
          renderField(subField)
        )}

      </Row>
    )
    )
  }

  const createEditFields = (): any => {

    if (loading) {
      return (<div className="panel-loading">
        <CustomLoader></CustomLoader>
      </div>);
    } else if (formSchema && formSchema.length > 0) {

      return (
        <>
          <Form form={form} layout="vertical" className="w-100 repo-entry-details" onFinish={onSubmit}>
            <div className="text-right">
              {viewPageBluPrint?.hideEmptyFeilds && (<Checkbox checked={selectCheckBox}
                onChange={() => setSelectCheckBox(!selectCheckBox)}>Hide Empty Field</Checkbox>)}
            </div>
       
            <Row className={"repo-entry-form"}>{renderFields()}</Row>
            <Row>{renderFinalApprovingAuthority()}</Row>
            {getIndexOfAccessLevel(userAccessLevel) >
              getIndexOfAccessLevelFromVal(AccessLevel.READ) && allowEdits ? (
              footer()
            ) : (
              <></>
            )}

          </Form>

          <>{renderActions()}</>
        </>
      );
    }
  };

  const footer = () =>
    <div className="text-right w-100 mt-2">
      <>
        {
          (enableStepBack ? (<Button className="button-custom-margin" type="default" onClick={() => onStepAction && onStepAction(StepAction.BACK)}>
            {"Back"}
          </Button>) : (<></>))
        }
        {
          (enableStepNext ? (<><Button ref={submitBtn} className="button-custom-margin" type="primary" htmlType="submit" value={JSON.stringify({ "actionType": "stepActionNext" })}>
            {"Save & Continue"}
          </Button>
            {(viewPageBluPrint.resetButton !== true) ? <></> :
              <Button className="button-custom-margin" type="primary" htmlType="button"
                onClick={() => resetFields()}
              >
                Reset
              </Button>}
          </>) : (<></>))
        }
        {
          (enableStepSubmit ? (<Button ref={submitBtn} className="button-custom-margin" type="primary" htmlType="submit" value={JSON.stringify({ "actionType": "stepActionSubmit" })}>
            {"Submit"}
          </Button>) : (<></>))
        }
        {
          (isEditClicked || isCreateFlow ? (
            <div className="text-right mx-3 mt-2 repo-entry">

              {(hideActions?.find(action => action === "Save") || enableStepNext || enableStepSubmit) ? <></> :
                <Button className="button-custom-margin" type="primary" htmlType="submit" loading={saveLoading}>
                  {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Save")?.label) ?? "Save"}
                </Button>}

              {(hideActions?.find(action => action === "Cancel") || enableStepNext || enableStepSubmit) ? <></> :
                <Button
                  className="button-custom-margin"
                  type="default"
                  hidden={isCreateFlow || getIndexOfPlatformAction(platformAction) ===
                    getIndexOfPlatformActionFromVal(RowLevelAction.CREATEWITHCONTEXT)}
                  onClick={() => setIsEditClicked(false)}
                >
                  {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Cancel")?.label) ?? "Cancel"}
                </Button>}

            </div>
          ) : (
            (hideActions?.find(action => action === "Cancel") || enableStepNext || enableStepSubmit) ? <></> :
              hideEdit && <Button type="primary" onClick={() => setIsEditClicked(true)}>
                {(platformActionLabels?.find(actionLabel => actionLabel.actionName === "Edit")?.label) ?? "Edit"}
              </Button>
          ))
        }
      </>

      {
        extraActionsOnRecord?.filter(extraAction => evaluateVisibilityOfAction(extraAction, editForm, form.getFieldsValue, urlparams))
          ?.filter(extraAction => extraAction.action ? (getIndexOfPlatformAction(platformAction) ===
            getIndexOfPlatformActionFromVal(extraAction.action)) : true)
          .map(extraAction => <Button className="button-custom-margin" value={JSON.stringify(extraAction)} htmlType={extraAction.performFormValidation ? "submit" : "button"} type="primary" onClick={() => extraAction.performFormValidation ? console.log("it is going to submit the form.") : executeExtraAction(recordId, form.getFieldsValue(), urlparams, extraAction, refreshTable, setOpen, setError)}>
            {extraAction.actionName}
          </Button>)
      }

    </div>

  return createEditFields();
};

export default RepoEntryDetails;